import { CLINIC } from "../site/data";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-primary text-primary-foreground pt-24 pb-12">
    <div className="mx-auto max-w-[1600px] px-6 md:px-10">
      <div className="border-b border-primary-foreground/15 pb-16">
        <h2 className="font-serif font-light leading-[0.9] text-5xl sm:text-7xl lg:text-[9rem]">
          Amar Sagoo<span className="text-secondary">.</span>
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 py-16">
        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.2em] text-accent mb-5">Contact</p>
          <p className="text-primary-foreground/80 mt-3">{CLINIC.phone}</p>
          <p className="text-primary-foreground/80">{CLINIC.email}</p>
        </div>
        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.2em] text-accent mb-5">Hours</p>
          <ul className="space-y-2">
            {CLINIC.hours.map((h) => (
              <li key={h.day} className="flex justify-between max-w-xs text-primary-foreground/80">
                <span>{h.day}</span>
                <span>{h.time}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.2em] text-accent mb-5">A Note</p>
          <p className="text-primary-foreground/80 leading-relaxed">
            If you or someone you love is in crisis, please call your local emergency number immediately. You are not alone.
          </p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row justify-between gap-4 text-xs text-primary-foreground/50 uppercase tracking-[0.14em]">
        <p>© {new Date().getFullYear()} {CLINIC.name}. All rights reserved.</p>
        <p>Compassionate Addiction Medicine</p>
      </div>
    </div>
  </footer>
);
